import { checkIfSelected, selectContentControl } from "./ContentControl";
import { closeCopyCutPasteMessagePanel, openPanel } from "../index";
import { CopyCutPasteInstance } from "./CopyCutPaste";
import { COPY_CUT_PASTE_PANEL_MESSAGE, EDIT_OBJECT, OBJECTS_LIST } from "../utils/constants/navigation";
import { CoObjectItem } from "../components/interfaces/CoObject";

export const extractSelectedContentControl = async (): Promise<string> => {
  try {
    const response = await checkIfSelected();
    if (!response) return null;
    if (!Array.isArray(response)) {
      return response.id + "";
    }
    return response?.[0]?.id + "";
  } catch (e) {
    return null;
  }
};

export async function actionCutContentControl(event) {
  const cutSuccessfully = await CopyCutPasteInstance.cut();
  event.completed();

  if (!cutSuccessfully) {
    return await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
  }
  await closeCopyCutPasteMessagePanel();
}

export async function actionCopyContentControl(event) {
  await CopyCutPasteInstance.copy();
  event.completed();

  await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
}

export async function actionPasteContentControl(event) {
  const [pastedSuccessfully, pastedElements] = await CopyCutPasteInstance.paste();
  event.completed();

  // error event
  if (!pastedSuccessfully) {
    return await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
  }
  //cut event
  if (!pastedElements) return await closeCopyCutPasteMessagePanel();
  //copy event
  if (pastedElements?.length === 1) {
    const isSelected = await selectContentControl({
      contentControlId: pastedElements[0]?.contentControlId,
    } as CoObjectItem);
    if (isSelected) await openPanel({ ...event, source: { id: EDIT_OBJECT } });
    return;
  }
  if (pastedElements?.length > 1) {
    await openPanel({ ...event, source: { id: OBJECTS_LIST } });
  }
}
